import apiClient from '@/services/axios'

export async function put(userId, tierLevelData) {
    var response = await apiClient.put('/users/' + userId + '/tier-level', tierLevelData)
    if (response) {
        return response.data
    }

    throw new Error('Unable to update User Tier Level.')
} 